import { styled } from '../../Utilities';
import { CalloutContentBase } from './CalloutContent.base';
import { getStyles } from './CalloutContent.styles';

export const CalloutContent = styled(CalloutContentBase, getStyles, undefined, { scope: 'CalloutContent' });
